import React, { useEffect, useRef, useState } from "react";

// Formik Validation

import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { Row, Col, Form, Label, Input, Button } from "reactstrap";

// import images
// import verificationImg from "";
import "assets/scss/custom/pages/_signup.scss";
import ToastDialog from "components/Common/ToastDialog";
import { sendLoginOtp, verifyLoginOtp } from "http/auth/login";

const VerifyLogin = () => {
  const [num, setNum] = useState(0);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [searchParams] = useSearchParams();
  const { uuid } = useParams();
  const [otp, setOtp] = useState("");

  let intervalRef = useRef();
 
  const decreaseNum = () => {
    setNum((prev) => prev - 1);
  };
  const navigate = useNavigate();
  //meta title
  document.title = "Account Verification | DMS";

  // const otpValue = []

  useEffect(() => {
    if (num == 0) {
      clearInterval(intervalRef.current);
    }
  }, [num]);

  const getParamsValue = (key) => {
    return searchParams.get(key) || "";
  };

  const handleChange = (index, value) => {
    const inputValue = value.target.value;
    const updatedOtp = otp ? otp.split('') : Array(4).fill('');

    // Update the OTP array with the entered value
    updatedOtp[index - 1] = inputValue;

    setOtp(updatedOtp.join(''));

    if (inputValue === '' && index > 1) {
      // If the current input is empty, move the focus to the previous input field
      const prevInput = document.getElementById(`digit${index - 1}-input`);
      if (prevInput) {
        prevInput.focus();
      }
    } else if (inputValue !== '' && index < 4) {
      // If a character is entered and it's not the last field, move the focus to the next input field
      const nextInput = document.getElementById(`digit${index + 1}-input`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };


  const startResendInterval = (duration) => {
    setNum(duration);
    intervalRef.current = setInterval(decreaseNum, 1000);
  };

  const submitVerifyOTP = () => {
    let otpValue = otp.split("");
    const otpFilter = otpValue.filter((o) => o.length > 0);
    if (otpFilter.length != 4) {
      setToastInfo({
        message: "Enter valid OTP",
        showToast: true,
        role: "error",
      });
      return;
    }


    const postParams = {
      uuid: uuid,
      otp: otpValue.join(""),
    };
    verifyLoginOtp(postParams)
      .then((result) => {
        if (result.status) {
          const { data, tokens, permissions } = result;
          localStorage.setItem("user", JSON.stringify(data))
          localStorage.setItem("tokens", JSON.stringify(tokens))
          localStorage.setItem("permissions", JSON.stringify(permissions))
          if (data.roleName == "dealer") {
            navigate(`/customer/dashboards`)
          } else if (data.roleName == "it_admin") {
            navigate(`/it_admin/users`)
          }
          else {
            navigate(`/${data.roleName}/dashboard`)
          }
        } else {
          const { message } = result;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((e) => { })
      .finally((f) => { });
  };

  const reSendOTP = () => {
    if (otp) {
      for (let i = 1; i <= 4; i++) {
        let input = document.getElementById(`digit${i}-input`)
        if (input.value) {
          input.value = ""
        }
      }
      setOtp("")
    }

    const postParams = {
      uuid: uuid,
    };
    sendLoginOtp(postParams)
      .then((result) => {
        if (result.status) {
          setToastInfo({
            message: "OTP sent successfully",
            showToast: true,
            role: "success",
          });
          startResendInterval(120);
        } else {
          const { message } = result;
          setToastInfo({ message: message, showToast: true, role: "error" });
        }
      })
      .catch((e) => { })
      .finally((f) => { });
  };

  const timerStr = () => {
    const seconds = Math.floor(num % 60);
    const minutes = Math.floor((num / 60) % 60);

    const minStr = minutes < 10 ? `0${minutes}`.slice(-2) : minutes
    const secStr = seconds < 10 ? `0${seconds}`.slice(-2) : seconds
    return `${minStr}:${secStr}`;
  };

  const handlekeyPress = (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      submitVerifyOTP();
    }
  }

  return (
    <React.Fragment>
      <div className="bg-auth account-pages account-pages-bg">
        
        <Row className="justify-content-center  w-100 h-100 align-items-center w-100 scrollable-height">
          <Col md={6}
            lg={7} xl={8} className="d-none d-md-block" style={{ flex: 'auto' }}>
            <div className="left-section h-100">
              <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                <img
                  // src={verificationImg}
                  src="/otp.svg"
                  alt=""
                  className="img-fluid verification-img"
                />
              </div>
            </div>
          </Col>
          <Col
            md={6}
            lg={5}
            xl={4}
            style={{
              overflow: "hidden",
              overflowX: "hidden",
              overflowY: "hidden",
            }}
            className="d-flex justify-content-center"
          >
            <div className="form-layout-section ms-4 ms-md-0 h-100 login-section">
              <div className="d-flex justify-content-center">
                <img
                  src={"/subros_logo.png"}
                  alt=""
                  className="img-fluid ci-logo"
                />
              </div>
              <div className="d-flex flex-column">
                <div className="p-2">
                  <div className="text-center">
                    <div className="avatar-md mx-auto">
                      <div className="avatar-title rounded-circle bg-light">
                        <i className="bx bxs-envelope h1 mb-0 "></i>
                      </div>
                    </div>
                    <div className="p-2 mt-4 d-flex flex-column justify-items-center">
                      <h4>Verify your OTP</h4>
                      <p className="mb-5">
                        Please enter the 4-digit code you received via provided mobile no. or email id to verify your account.
                        <span className="fw-semibold">
                          {getParamsValue("mobile")}
                        </span>
                      </p>

                      <Form onKeyDown={handlekeyPress}>
                        <div className="d-flex justify-content-center">
                          <Input
                            style={{ width: '44.8px' }}
                            type="text"
                            className="form-control form-control-lg text-center two-step ms-2 me-2"
                            maxLength="1"
                            tabIndex="1"
                            id="digit1-input"
                            onChange={(e) => handleChange(1, e)}
                          />
                          <Input
                            style={{ width: '44.8px' }}
                            type="text"
                            className="form-control form-control-lg text-center two-step  ms-2 me-2"
                            maxLength="1"
                            tabIndex="2"
                            id="digit2-input"
                            onChange={(e) => handleChange(2, e)}
                          />
                          <Input
                            style={{ width: '44.8px' }}
                            type="text"
                            className="form-control form-control-lg text-center two-step  ms-2 me-2"
                            maxLength="1"
                            tabIndex="3"
                            id="digit3-input"
                            onChange={(e) => handleChange(3, e)}
                          />
                          <Input
                            style={{ width: '44.8px' }}
                            type="text"
                            className="form-control form-control-lg text-center two-step  ms-2 me-2"
                            maxLength="1"
                            tabIndex="4"
                            id="digit4-input"
                            onChange={(e) => handleChange(4, e)}
                          />
                        </div>
                      </Form>
                      <div className="mt-4">
                        <Button
                          style={{
                            backgroundColor: "#344fa0",
                            textAlign: "center",
                            fontWeight: "500",
                            color: "white"

                          }}
                          type="submit"
                          onClick={() => submitVerifyOTP()}
                        >
                          <span>Submit</span>
                        </Button>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="mt-2 text-center">
                  {num == 0 && (
                    <p>
                      Didn&apos;t receive a code ?{" "}
                      <a
                        href="#"
                        className="fw-medium text-primary"
                        onClick={() => reSendOTP()}
                      >
                        {" "}
                        <span style={{ color: "#344fa0" }}> Resend </span>
                      </a>{" "}
                    </p>
                  )}
                  {num > 0 && (
                    <p>
                      Resend OTP in{" "}
                      <a href="#" className="fw-medium" style={{ color: "#344fa0" }}>
                        {" "}
                        {timerStr()}{" "}
                      </a>{" "}
                    </p>
                  )}
                </div>
              </div>
              <Row className="d-flex w-60 m-auto justify-content-center d-block ">
                <Col md={12} lg={9} xl={9}>

                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default VerifyLogin;
